import { Modal, Image, Stack, Group, Text, Button, Box } from '@mantine/core';
import { IconSend } from '@tabler/icons-react';

type ImagePreviewModalProps = {
  opened: boolean;
  onClose: () => void;
  imageUrl: string | null;
  title?: string;
  confirmFile: File;
  onConfirm: () => void;
  submitting?: boolean;
};

export function ImagePreviewModal({
  opened,
  onClose,
  imageUrl,
  title,
  confirmFile,
  onConfirm,
  submitting,
}: ImagePreviewModalProps) {
  if (!imageUrl) return null;

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={title || '发送预览'}
      size="lg"
      centered
      radius="lg"
      padding={0}
      styles={{
        header: {
          padding: '16px 20px',
          borderBottom: '1px solid var(--mantine-color-gray-2)',
          flexShrink: 0,
        },
        body: {
          padding: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          maxHeight: 'min(80vh, 700px)',
        },
        content: {
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        },
      }}
    >
      {/* Image area — flex-grows to fill space between header and footer */}
      <Box
        style={{
          background: 'var(--mantine-color-white)',
          flex: 1,
          minHeight: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          padding: '16px',
        }}
      >
        <Image
          src={imageUrl}
          alt="Preview"
          fit="contain"
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
            borderRadius: 8,
          }}
        />
      </Box>

      <Box p="lg" bg="var(--locs-panel)" style={{ flexShrink: 0, borderTop: '1px solid var(--locs-border)' }}>
        <Group justify="space-between" align="center" wrap="wrap">
          <Stack gap={2} style={{ flex: 1, minWidth: 0 }}>
            <Text fw={700} size="sm">发送这张图片？</Text>
            <Text size="xs" c="dimmed" truncate>{confirmFile.name}</Text>
          </Stack>
          <Group gap="sm">
            <Button variant="default" onClick={onClose} disabled={submitting}>
              取消
            </Button>
            <Button
              onClick={onConfirm}
              loading={submitting}
              leftSection={<IconSend size={16} />}
            >
              发送图片
            </Button>
          </Group>
        </Group>
      </Box>
    </Modal>
  );
}
